import { Outlet } from 'react-router-dom'
import { MENU_HEIGHT, Z_INDEX } from '../../constants'
import Overflow from '../Overflow'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'

export default function Onboard() {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: MENU_HEIGHT,
        bottom: 0,
        width: '100%',
        bgcolor: 'background.default',

        // backdropFilter: 'blur(6px)',
        zIndex: Z_INDEX.GRAPH
      }}>
      <Overflow>
        <Grid
          container
          columnSpacing={{ xs: 0, sm: 8 }}
          rowSpacing={{ xs: 0, sm: 2 }}
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            maxWidth: 'md',
            margin: 'auto'
          }}>
          <Outlet />
        </Grid>
      </Overflow>
    </Stack>
  )
}
